import { React, useContext, useState, } from "react";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import { TableHeaderContext } from "../../Contexts/TableHeaderContext";
import IndustryFilter from "../../Components/RefineSearchComponents/IndustryFilter";
import SectorFilter from "../../Components/RefineSearchComponents/PESectorFilter";
import CityFilter from "../../Components/RefineSearchComponents/CityFilter";
import InvestorTypeFilter from "../../Components/RefineSearchComponents/InvestorTypeFilter";
import DealRangeFilter from "../../Components/RefineSearchComponents/DealRangeFilter";
import FirmTypeFilter from "../RefineSearchComponents/FirmTypeFilter";
import Switch from "../RefineSearchComponents/AndOrToggleSwtich";
import Tags from "../RefineSearchComponents/Tags";
import InvestorDealFilter from '../RefineSearchComponents/InvestorDealFilter'
import InvestorCityTag from '../RefineSearchComponents/InvestorCityTag';
import { UserContext } from "../../Contexts/UserContext";
import axios from "axios";
import { filterSectorByIndutry, refineSearchSubFirmTypeUrl, tagList } from "../../Config/config";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import InvestorDealRangeFilter from "../RefineSearchComponents/InvestorDealRangeFilter";
import { TableDataContext } from "../../Contexts/TableDataContext";
import Constants from "../../Constants";
import { Tooltip } from "antd";
import { FaInfoCircle } from "react-icons/fa";
import DefinitionModal from "../TagDefinitionModal";
import ToggleButton from "../RefineSearchComponents/ToggleAndOrSwitch";
import TargetCompany from '../RefineSearchComponents/TargetCompany';
import Investor from "../RefineSearchComponents/Investor";
import LAdvisor from '../RefineSearchComponents/lAdvisor';
import TAdvisor from '../RefineSearchComponents/tAdvisor';
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import FirmTypeSubMenu from "../RefineSearchComponents/FirmTypeSubMenu";
/**
 * The `InvestorExistRefineSearch` function is a React component that renders a form for refining
 * search filters for investors.
 * @returns a JSX element.
 */
export default function InvestorExistRefineSearch({ customPathname, generalPathname }) {
    const {
        InvestorOptions , setInvestorOptions ,dbDropdown , setDbDropdown ,dropdown,Sectors,setSubFirmType, 
        setSectors,SwitchState,setSwitchState,lAdvisorsOptions,setlAdvisorsOptions,tAdvisorsOptions , settAdvisorsOptions , TargetCompanyOptions , setTargetCompanyOptions ,
        onErrorHandler, setrefineSearchFilters,setMonthPickerValue ,refineSearchFilters, getSectorByIndustry, accessControl } = useContext(PeFilterContext);
    const { setCurrentPage } = useContext(TableDataContext);
    const [select, setSelected] = useState(32);
    const { getToken } = useContext(UserContext);
    const location = useLocation()
    const navigate = useNavigate();
    const { pathname } = useLocation()
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const isFromSearchedList = ()=> refineSearchFilters[location?.state?.prevPath]?.globalSearch?.length > 0 ? true : false

    //local updated options
    const [IndustriesOptions, setIndustriesOptions] = useState([])
    const [SectorOptions, setSectorOptions] = useState([])

    const [CityOptions, setCityOptions] = useState([])
    const [InvestorTypeOptions, setInvestorTypeOptions] = useState([])
    const [FirmTypeOptions, setFirmTypeOptions] = useState([])
    const [FirmSubTypeOptions, setFirmSubTypeOptions] = useState([])
    const [DealRange, setDealRange] = useState({ from: "", to: "" })
    const [invDealRange, setInvDealRange] = useState({ from: "", to: "" })
    const [TagSwitchState, setTagSwitchState] = useState(true)
    const [TagsOptions, setTagsOptions] = useState([])
    const [MinDealOptions, setMinDealOptions] = useState([])
    const [MaxDealOptions, setMaxDealOptions] = useState([])
    const [MinDealRangeOptions, setMinDealRangeOptions] = useState([])
    const [MaxDealRangeOptions, setMaxDealRangeOptions] = useState([])
    
    // State for managing which filter section is active
    const [activeFilterSection, setActiveFilterSection] = useState("keyword");
    
    // State for managing which individual filter popup is open
    const [openFilterPopup, setOpenFilterPopup] = useState(null);

    // Helper functions to count applied filters for each section
    const getDealFiltersCount = () => {
        let count = 0;
        if (DealRange?.from || DealRange?.to) count++;
        if (invDealRange?.from || invDealRange?.to) count++;
        return count;
    };

    const getCompanyFiltersCount = () => {
        let count = 0;
        if (IndustriesOptions.some(option => option.isChecked)) count++;
        if (SectorOptions.some(option => option.isChecked)) count++;
        return count;
    };

    const getInvestorFiltersCount = () => {
        let count = 0;
        if (InvestorTypeOptions.some(option => option.isChecked)) count++;
        if (FirmTypeOptions.some(option => option.isChecked)) count++;
        if (CityOptions.some(option => option.isChecked)) count++;
        return count;
    };

    const getKeywordFiltersCount = () => {
        let count = 0;
        if (TagsOptions.length > 0) count++;
        if (InvestorOptions.some(option => option.isChecked)) count++;
        if (TargetCompanyOptions.some(option => option.isChecked)) count++;
        if (lAdvisorsOptions.some(option => option.isChecked)) count++;
        if (tAdvisorsOptions.some(option => option.isChecked)) count++;
        return count;
    };

   /**
    * The function `applyFilter` updates the refine search filters based on the selected options.
    */
    const applyFilter = () => {
        const selectedIndustries = IndustriesOptions.filter(industry => industry.isChecked);
        const selectedSectors = SectorOptions.filter(option => option.isChecked);
        const selectedCity = CityOptions?.filter(option => option.isChecked);
        const selectedInvestorType = InvestorTypeOptions?.filter(option => option.isChecked);
        const selectedFirm = FirmTypeOptions?.filter(option => option.isChecked);
        const selectedFirmSubTypes = FirmSubTypeOptions?.filter(option => option.isChecked);
        const invMin = MinDealOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const invMax = MaxDealOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const minDealRange = MinDealRangeOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const maxDealRange = MaxDealRangeOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedOperators = SwitchState;
        const selectedlAdvisors = lAdvisorsOptions?.filter(option => option.isChecked);
        const selectedtAdvisors = tAdvisorsOptions?.filter(option => option.isChecked);
        const selectedTargetCompany = TargetCompanyOptions?.filter(option => option.isChecked); 
        const selectedInvestor = InvestorOptions?.filter(option => option.isChecked); 
        const firmTypeNames = selectedFirm?.filter(firm => firm.isChecked).map(firm => firm.name) ?? [];
        let filteredFirmSubTypes = null;

        const excludedNames = ['Healthcare(PE)', 'Cleantech(PE)', 'Healthcare(VC)', 'Cleantech(VC)'];

        if (firmTypeNames.includes('PE') || firmTypeNames.includes('VC')) {
            filteredFirmSubTypes = selectedFirmSubTypes?.filter(sub => {
                const isPE = sub.name?.includes('(PE)') || sub.originalName?.includes('(PE)');
                const isVC = sub.name?.includes('(VC)') || sub.originalName?.includes('(VC)');

                if (firmTypeNames.includes('PE') && firmTypeNames.includes('VC')) {
                    return isPE || isVC;
                } else if (firmTypeNames.includes('PE')) {
                    return isPE;
                } else if (firmTypeNames.includes('VC')) {
                    return isVC;
                }
                return false;
            })?.map(sub => {
                if (!excludedNames.includes(sub.name)) {
                    return {
                        ...sub,
                        name: sub.name.replace(/\((PE|VC)\)/, ''),
                    };
                }
                return sub;
            }) ?? null;

            if (filteredFirmSubTypes.length === 0) {
                filteredFirmSubTypes = null;
            }
        }

        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{
                ...prev[generalPathname],
                industry: selectedIndustries,
                sector: selectedSectors,
                city: selectedCity,
                investorType: selectedInvestorType,
                firmType: selectedFirm,
                firm_Sub_type: filteredFirmSubTypes,
                tags: TagsOptions,
                operator: TagSwitchState ? 1 : 0,
                deals_operator : selectedOperators,
                ladvisors: selectedlAdvisors,
                tadvisors: selectedtAdvisors,
                investor_id : selectedInvestor ,
                target_company:selectedTargetCompany,
            },
            [customPathname]: {
                ...prev[customPathname],
                dealRange: DealRange?.from != "" && DealRange?.to != "" ? [{ id: 0, name: DealRange?.from }, { id: 1, name: DealRange?.to }] : [],
                dealInvestorRange: invDealRange?.from != "" && invDealRange?.to != "" ? [{ id: 0, name: invDealRange?.from }, { id: 1, name: invDealRange?.to }] : []
            },
        }))
    }

   /**
    * The function `resetFilter` resets a specific filter in the `refineSearchFilters` state object by
    * setting its value to an empty object.
    */
    const resetFilter = () => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{},
            [customPathname]: {}
        }))
        setlAdvisorsOptions([]);
        settAdvisorsOptions([]);
        setTargetCompanyOptions([]);
        setSectors([]);
        setInvestorOptions([]);
    }


    // Submitting Refine Search Form 
   /**
    * The function `refineSearchFilter` updates search filters, resets the month picker value, applies
    * filters, deselects any selected items, and navigates to a custom pathname if the current pathname
    * is different.
    * @param event - The `event` parameter is an object that represents the event that triggered the
    * function. It could be an event like a button click or a form submission.
    */
    const refineSearchFilter = (event) => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{},
            [customPathname]: {globalSearch:[],
            }
        }))
        if(isFromGlobalSearch() || isFromSearchedList()){
            setMonthPickerValue(Constants.initialMonthRange)
        }
        event.preventDefault();
        setCurrentPage(1);
        applyFilter();
        setSelected(false)
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }

    }

 /**
  * The `onResetClick` function resets the current page, filters, and navigates to a custom pathname if
  * it is different from the current location.
  * @param event - The event parameter is an object that represents the event that triggered the
  * function. In this case, it is likely a click event on a reset button.
  */
    const onResetClick = (event) => {
        event.preventDefault();
        setCurrentPage(1);
        resetFilter()
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }

   /**
    * The function `accordionClick` sets the selected value to either 0 or the provided value.
    * @param val - The `val` parameter is a value that is passed to the `accordionClick` function. It
    * is used to determine whether the accordion should be selected or deselected.
    */
    const accordionClick = (val) => {
        if (val === select) {
            setSelected(0);
        } else {
            setSelected(val);
        }
    };

    useEffect(() => {
        const ids = IndustriesOptions?.length > 0 ? 
            IndustriesOptions.filter(industry => industry.isChecked)?.map(option => option.id) : [];

        if (ids?.length > 0) {
            getSectorByIndustry(ids, "investments")
        } else {
            setSectors([])
        }

    }, [IndustriesOptions])

    useEffect(() => {
        if(accessControl?.peindustries?.id?.length > 0){
            const ids = accessControl ? accessControl?.peindustries?.id : []
            getSectorByIndustry(ids, "investments")
        }
    }, [])

    // useEffect(() => {
    //     const ids = FirmTypeOptions?.filter(industry => industry.isChecked)?.map(option => option.id);

    //     if (ids?.length > 0) {
    //         let firmType = "All";
    //         if (ids.length === 1) {
    //             if (ids[0] === 1) firmType = "PE";
    //             else if (ids[0] === 2) firmType = "VC";
    //         }

    //         axios.post(refineSearchSubFirmTypeUrl, {
    //             firm_type: firmType,
    //         }, {
    //             headers: {
    //                 "Authorization": getToken()
    //             }
    //         }).then(response => {
    //             if (response.status === 200) {
    //                 setSubFirmType(response.data?.firmType ?? []);
    //             } else {
    //                 setSubFirmType([]);
    //             }
    //         }).catch(onErrorHandler);
    //     } else {
    //         setSubFirmType([]);
    //     }
    // }, [FirmTypeOptions]);

    const getSearchTags = async (searchText, type) => {
        try {
        const response = await axios.post(tagList, {
            "tag": searchText,
            "includes_secondary_tags": secondaryTagCheck,
            "type"    : type

        }, {
            headers: {
            "Authorization": getToken()
            }
        });

        if (response.status === 200) {
            return response.data;
        } else {
            return [];
        }
        } catch (error) {
            return [];
        }
    }


    const fetchData = async () => {
        const tags = await getSearchTags("ALL", "noncompetitor");
        const competitorTags = await getSearchTags("ALL", "competitor")
        const secondaryTags = await getSearchTags("ALL", "secondary")
        // console.log(tags, competitorTags, 'promi')
        openTagModal(tags, competitorTags, secondaryTags)
    };
    
    const [showDefinitionModal, setShowDefinitionModal] = useState(false);
    const [defValues, setDefValues] = useState({})
    const [secondaryTagCheck, setSecondaryTagCheck] = useState(true);
    console.log(defValues, 'showValues');

    const openTagModal = (non_comp, comp, s_tags) => {
        setShowDefinitionModal(true);
        setDefValues({
            non_comp: non_comp,
            comp: comp,
            s_tags: s_tags
        })
    }

    const defCloseHandler = () =>{
        setShowDefinitionModal(false);
        setDefValues({})
    }

    const handleDbToggle = () => {
        setDbDropdown(!dbDropdown);
    };

    const getPeVcSelectedTypes = () => {
        return FirmTypeOptions?.filter(option => 
            (option.id === 1 || option.id === 2) && option.isChecked
        ) || [];
        };
    
    return (
        <div className="bg-white">
            <div className="h-full flex flex-col">
                <form onSubmit={refineSearchFilter} onReset={onResetClick} className="min-h-full w-full flex flex-col">
                    <main className="flex-1 w-full py-4 overflow-y-auto">
                        <div className="flex flex-col md:grid md:grid-cols-8 gap-2 md:gap-4">
                            {/* Left column - Headers */}
                            <div className="flex flex-row md:flex-col gap-1 md:gap-2 border-b md:border-b-0 md:border-r border-gray-300 pb-2 md:pb-0 md:pr-4 md:max-w-[320px] md:col-span-2 items-baseline md:items-stretch overflow-x-auto flex-wrap md:flex-nowrap">
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'keyword' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'keyword' ? null : 'keyword')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Keyword Search</span>
                                        {getKeywordFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'keyword' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getKeywordFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'keyword' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'deal' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'deal' ? null : 'deal')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Deal</span>
                                        {getDealFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'deal' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getDealFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'deal' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'company' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'company' ? null : 'company')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Company</span>
                                        {getCompanyFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'company' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getCompanyFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'company' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'investor' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'investor' ? null : 'investor')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Investor</span>
                                        {getInvestorFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'investor' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getInvestorFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'investor' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                            </div>
                            
                            {/* Right column - Filters */}
                            <div className="overflow-visible mt-4 md:mt-0 pb-20 md:pb-0 md:col-span-6">
                                <div className={`w-full md:w-1/2 ${activeFilterSection === 'keyword' ? '' : 'hidden'} relative`}>
                                        <div className="space-y-4">
                                            <div className="flex items-center gap-4 border border-gray-300 rounded-md p-1 md:gap-0">
                                                <div className="p-0 m-0 bg-white input-search relative flex items-center w-full">
                                                    <Tags
                                                        TagsOptions={TagsOptions}
                                                        customPathname={generalPathname}
                                                        setTagsOptions={setTagsOptions}
                                                        getSearchTags={getSearchTags}
                                                    />
                                                    <Switch
                                                        SwitchState={TagSwitchState}
                                                        setSwitchState={setSwitchState}
                                                        customPathname={generalPathname} 
                                                    />
                                                </div>
                                                <div className="md:hidden flex items-center">
                                                    <Tooltip title='Tag List'>
                                                        <FaInfoCircle 
                                                            size={16} 
                                                            color="grey" 
                                                            className="cursor-pointer px-[1px]"
                                                            onClick={fetchData}
                                                        />
                                                    </Tooltip>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: "0.5rem" }} className="mt-2 cursor-pointer flex justify-end items-center text-xs gap-1">
                                                <input type="checkbox" checked={secondaryTagCheck} onChange={() => setSecondaryTagCheck(!secondaryTagCheck)} title="includes secondary tags" />
                                                <span>include secondary tags</span>
                                            </div>
                                            <Tooltip title='Tag List'>
                                                <FaInfoCircle 
                                                    size={16} 
                                                    color="grey" 
                                                    className="cursor-pointer hidden md:block absolute md:left-[103%] md:top-0"
                                                    onClick={fetchData}
                                                />
                                            </Tooltip>
                                        </div>
                                        <div className="mt-4 space-y-4">
                                            <Investor 
                                                options={InvestorOptions}
                                                setOptions={setInvestorOptions}
                                                customPathname={generalPathname}
                                                accordionClick={() => accordionClick(32)}
                                                label="Investor"
                                                open={select === 32}
                                            />
                                            <TargetCompany 
                                                options={TargetCompanyOptions}
                                                setOptions={setTargetCompanyOptions}
                                                customPathname={generalPathname}
                                                accordionClick={() => accordionClick(31)}
                                                label="Company"
                                                open={select === 31}
                                            />
                                            <LAdvisor 
                                                options={lAdvisorsOptions}
                                                setOptions={setlAdvisorsOptions}
                                                customPathname={generalPathname}
                                                label="Legal Advisors"
                                                accordionClick={() => accordionClick(21)}
                                                open={select === 21}
                                            />
                                            <TAdvisor 
                                                options={tAdvisorsOptions}
                                                setOptions={settAdvisorsOptions}
                                                label="Transaction Advisors"
                                                customPathname={generalPathname}
                                                accordionClick={() => accordionClick(29)}
                                                open={select === 29}
                                            />
                                        </div>
                                    </div>
                                
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:gap-8 md:gap-y-8 ${activeFilterSection === 'deal' ? '' : 'hidden'}`}>
                                        <InvestorDealRangeFilter
                                            DealRange={DealRange}
                                            setDealRange={setDealRange}
                                            customPathname={customPathname}
                                            isPopupOpen={openFilterPopup === 'dealRange'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'dealRange' : null)}
                                        />
                                        <InvestorDealFilter
                                            customPathname={customPathname}
                                            invDealRange={invDealRange}
                                            setInvDealRange={setInvDealRange}
                                            isPopupOpen={openFilterPopup === 'investorDealRange'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'investorDealRange' : null)}
                                        />
                                    </div>
                                
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:gap-8 md:gap-y-8 ${activeFilterSection === 'company' ? '' : 'hidden'}`}>
                                        <IndustryFilter
                                            IndustriesOptions={IndustriesOptions}
                                            setIndustriesOptions={setIndustriesOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(1)}
                                            open={select === 1}
                                            isPopupOpen={openFilterPopup === 'industry'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'industry' : null)}
                                        />
                                        <SectorFilter
                                            SectorOptions={SectorOptions}
                                            setSectorOptions={setSectorOptions}
                                            accordionClick={() => accordionClick(2)}
                                            customPathname={generalPathname}
                                            open={select === 2}
                                            isPopupOpen={openFilterPopup === 'sector'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'sector' : null)}
                                        />
                                        <InvestorCityTag
                                            CityOptions={CityOptions}
                                            customPathname={customPathname}
                                            setCityOptions={setCityOptions}
                                            accordionClick={() => accordionClick(20)}
                                            open={select === 20}
                                            isPopupOpen={openFilterPopup === 'investorCity'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'investorCity' : null)}
                                        />
                                    </div>
                                
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:gap-8 md:gap-y-8 ${activeFilterSection === 'investor' ? '' : 'hidden'}`}>
                                        <InvestorTypeFilter
                                            InvestorTypeOptions={InvestorTypeOptions}
                                            setInvestorTypeOptions={setInvestorTypeOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(14)}
                                            open={select === 14}
                                            isPopupOpen={openFilterPopup === 'investorType'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'investorType' : null)}
                                        />
                                        <FirmTypeFilter
                                            FirmTypeOptions={FirmTypeOptions}
                                            setFirmTypeOptions={setFirmTypeOptions}
                                            FirmSubTypeOptions={FirmSubTypeOptions}  
                                            setFirmSubTypeOptions={setFirmSubTypeOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(16)}
                                            dataPath="investments"
                                            open={select === 16}
                                            isPopupOpen={openFilterPopup === 'firmType'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'firmType' : null)}
                                        />
                                    </div>
                                
                                <div className={`flex items-center justify-center h-40 text-gray-500 ${!activeFilterSection ? '' : 'hidden'}`}>
                                    <p>Select a filter category from the left to view available filters</p>
                                </div>
                            </div>
                        </div>
                    </main>
                </form>
            </div>
            {showDefinitionModal && <DefinitionModal 
                    values={defValues} 
                    onClose={defCloseHandler} 
                    TagsOptions={TagsOptions} 
                    setTagsOptions={setTagsOptions}
                    customPathname={generalPathname}
                />}
        </div>
    );
}
